<template>
    <input class="bar_input" :value="modelValue" @input="updateInput">
</template>

<script>
export default {
    name: 'my-input',
    props: {
        modelValue: [String, Number] // любое имя, пример "modelValue"
    },
    methods: {
        updateInput(event) {
            this.$emit('update:modelValue', event.target.value)
        }
    }
}
</script>

<style scoped>
.bar_input {
  font-size: 30px;
  /* color: #ff7d33; */
  color: var(--bar-color-main);
  background-color: transparent;
  /* border: 5px solid #ff7d33; */
  border: 5px solid var(--bar-color-main);
  border-radius: 15px;
  padding: 15px;
  margin-top: 10px;
}
</style>
